import { useState, useEffect } from "react";

const QrGenerator = () => {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [qrList, setQrList] = useState([]);

  // 🔹 Load saved data on page load
  useEffect(() => {
    const savedQrs = localStorage.getItem("qrData");
    if (savedQrs) {
      setQrList(JSON.parse(savedQrs));
    }
  }, []);

  // 🔹 Save data whenever qrList changes
  useEffect(() => {
    localStorage.setItem("qrData", JSON.stringify(qrList));
  }, [qrList]);

  const generateQR = () => {
    if (!name || !link) return;

    const newQR = {
      id: Date.now(),
      name,
      link,
    };

    setQrList([newQR, ...qrList]); // newest first
    setName("");
    setLink("");
  };

  const downloadQR = async (data, fileName) => {
    const url = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(
      data
    )}`;

    const response = await fetch(url);
    const blob = await response.blob();

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${fileName}.png`;
    a.click();
  };

  const deleteQR = (id) => {
    const updatedList = qrList.filter((qr) => qr.id !== id);
    setQrList(updatedList);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      {/* Input Card */}
      <div className="max-w-xl mx-auto bg-white p-6 rounded-2xl shadow mb-8">
        <h1 className="text-2xl font-semibold text-center mb-5">
          QR Code Generator
        </h1>

        <div className="grid gap-3 sm:grid-cols-2">
          <input
            type="text"
            placeholder="QR Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border rounded-lg px-3 py-2"
          />

          <input
            type="text"
            placeholder="Link / Text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            className="border rounded-lg px-3 py-2"
          />
        </div>

        <button
          onClick={generateQR}
          className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Generate QR
        </button>
      </div>

      {/* QR GRID */}
      <div className="max-w-6xl mx-auto">
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {qrList.map((qr) => (
            <div
              key={qr.id}
              className="bg-white rounded-2xl shadow hover:shadow-lg transition p-4 text-center"
            >
              <h2 className="font-semibold mb-2 truncate">
                {qr.name}
              </h2>

              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(
                  qr.link
                )}`}
                alt="QR"
                className="mx-auto mb-3"
              />

              <p className="text-xs text-gray-500 break-all mb-3">
                {qr.link}
              </p>

              <div className="flex gap-2">
                <button
                  onClick={() => downloadQR(qr.link, qr.name)}
                  className="flex-1 bg-green-600 text-white py-2 rounded-lg text-sm"
                >
                  Download
                </button>

                <button
                  onClick={() => deleteQR(qr.id)}
                  className="flex-1 bg-red-500 text-white py-2 rounded-lg text-sm"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QrGenerator;





// import { useState, useEffect } from "react";

// const API_URL = "http://localhost:5000/api/qr"; // Update if deployed

// const QrGenerator = () => {
//   const [name, setName] = useState("");
//   const [link, setLink] = useState("");
//   const [qrList, setQrList] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Fetch all QR codes from backend
//   const fetchQRs = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(API_URL);
//       const data = await res.json();
//       // Show newest first
//       setQrList(data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
//       setLoading(false);
//     } catch (err) {
//       console.error(err);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchQRs();
//   }, []);

//   // Generate new QR
//   const generateQR = async () => {
//     if (!name.trim() || !link.trim()) {
//       alert("Please enter both Name and Link");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ name: name.trim(), link: link.trim() }),
//       });

//       if (!res.ok) throw new Error("Failed to generate QR");

//       const newQR = await res.json();
//       setQrList([newQR, ...qrList]); // Show newest on top
//       setName("");
//       setLink("");
//     } catch (err) {
//       console.error(err);
//       alert("Error generating QR. Try again.");
//     }
//   };

//   // Delete QR
//   const deleteQR = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this QR?")) return;

//     try {
//       const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
//       const data = await res.json();

//       if (res.ok) {
//         setQrList(qrList.filter((qr) => qr._id !== id));
//       } else {
//         alert("Error deleting QR: " + data.message);
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Failed to delete QR. Try again.");
//     }
//   };

//   // Download QR
//   const downloadQR = async (data, fileName) => {
//     const url = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(
//       data
//     )}`;

//     const response = await fetch(url);
//     const blob = await response.blob();

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `${fileName}.png`;
//     a.click();
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4">
//       {/* Input Card */}
//       <div className="max-w-xl mx-auto bg-white p-6 rounded-2xl shadow mb-8">
//         <h1 className="text-2xl font-semibold text-center mb-5">
//           QR Code Generator
//         </h1>

//         <div className="grid gap-3 sm:grid-cols-2">
//           <input
//             type="text"
//             placeholder="QR Name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             className="border rounded-lg px-3 py-2"
//           />
//           <input
//             type="text"
//             placeholder="Link / Text"
//             value={link}
//             onChange={(e) => setLink(e.target.value)}
//             className="border rounded-lg px-3 py-2"
//           />
//         </div>

//         <button
//           onClick={generateQR}
//           className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
//         >
//           Generate QR
//         </button>
//       </div>

//       {/* QR Grid */}
//       <div className="max-w-6xl mx-auto">
//         {loading ? (
//           <p className="text-center text-gray-500">Loading QR codes...</p>
//         ) : qrList.length === 0 ? (
//           <p className="text-center text-gray-500">No QR codes found.</p>
//         ) : (
//           <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
//             {qrList.map((qr) => (
//               <div
//                 key={qr._id}
//                 className="bg-white rounded-2xl shadow hover:shadow-lg transition p-4 text-center"
//               >
//                 <h2 className="font-semibold mb-2 truncate">{qr.name}</h2>

//                 <img
//                   src={`https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(
//                     qr.link
//                   )}`}
//                   alt="QR"
//                   className="mx-auto mb-3"
//                 />

//                 <p className="text-xs text-gray-500 break-all mb-3">{qr.link}</p>

//                 <div className="flex gap-2">
//                   <button
//                     onClick={() => downloadQR(qr.link, qr.name)}
//                     className="flex-1 bg-green-600 text-white py-2 rounded-lg text-sm hover:bg-green-700"
//                   >
//                     Download
//                   </button>

//                   <button
//                     onClick={() => deleteQR(qr._id)}
//                     className="flex-1 bg-red-500 text-white py-2 rounded-lg text-sm hover:bg-red-600"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default QrGenerator;



// php code:


// import { useState, useEffect } from "react";

// const API_URL = "http://oys.co.in/#/api/qr.php"; // change to domain if hosted

// const QrGenerator = () => {
//   const [name, setName] = useState("");
//   const [link, setLink] = useState("");
//   const [qrList, setQrList] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // FETCH QRs
//   const fetchQRs = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${API_URL}/getQr.php`);
//       const data = await res.json();

//       // newest first (MySQL field)
//       setQrList(
//         data.sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         )
//       );
//       setLoading(false);
//     } catch (err) {
//       console.error(err);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchQRs();
//   }, []);

//   // ADD QR
//   const generateQR = async () => {
//     if (!name.trim() || !link.trim()) {
//       alert("Please enter both Name and Link");
//       return;
//     }

//     try {
//       const res = await fetch(`${API_URL}/addQr.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ name, link }),
//       });

//       const data = await res.json();

//       if (res.ok) {
//         setQrList([data, ...qrList]);
//         setName("");
//         setLink("");
//       } else {
//         alert(data.message || "Failed to add QR");
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // DELETE QR
//   const deleteQR = async (id) => {
//     if (!window.confirm("Delete this QR?")) return;

//     try {
//       const res = await fetch(`${API_URL}/deleteQr.php?id=${id}`);
//       const data = await res.json();

//       if (res.ok) {
//         setQrList(qrList.filter((qr) => qr.id !== id));
//       } else {
//         alert(data.message);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // DOWNLOAD QR
//   const downloadQR = async (data, fileName) => {
//     const url = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(
//       data
//     )}`;

//     const blob = await (await fetch(url)).blob();
//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `${fileName}.png`;
//     a.click();
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4">
//       {/* Input */}
//       <div className="max-w-xl mx-auto bg-white p-6 rounded-xl shadow mb-8">
//         <h1 className="text-2xl font-semibold text-center mb-4">
//           QR Code Generator
//         </h1>

//         <div className="grid gap-3 sm:grid-cols-2">
//           <input
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="QR Name"
//             className="border p-2 rounded"
//           />
//           <input
//             value={link}
//             onChange={(e) => setLink(e.target.value)}
//             placeholder="Link"
//             className="border p-2 rounded"
//           />
//         </div>

//         <button
//           onClick={generateQR}
//           className="w-full mt-4 bg-blue-600 text-white py-2 rounded"
//         >
//           Generate QR
//         </button>
//       </div>

//       {/* List */}
//       <div className="max-w-6xl mx-auto">
//         {loading ? (
//           <p className="text-center">Loading...</p>
//         ) : qrList.length === 0 ? (
//           <p className="text-center">No QR codes</p>
//         ) : (
//           <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
//             {qrList.map((qr) => (
//               <div key={qr.id} className="bg-white p-4 rounded shadow text-center">
//                 <h2 className="font-semibold mb-2">{qr.name}</h2>

//                 <img
//                   src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(
//                     qr.link
//                   )}`}
//                   alt="QR"
//                   className="mx-auto mb-3"
//                 />

//                 <p className="text-xs break-all mb-3">{qr.link}</p>

//                 <div className="flex gap-2">
//                   <button
//                     onClick={() => downloadQR(qr.link, qr.name)}
//                     className="flex-1 bg-green-600 text-white py-2 rounded"
//                   >
//                     Download
//                   </button>

//                   <button
//                     onClick={() => deleteQR(qr.id)}
//                     className="flex-1 bg-red-500 text-white py-2 rounded"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default QrGenerator;
